module.exports = __webpack_public_path__ + "static/img/logisticsBigData.b140594.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logisticsBigData.png
// module id = YghQ
// module chunks = 44